import { useState } from 'react';
import logo from '../../assets/logo.png';
import { requestOtp } from '../../services/auth';
import { createIdentityUser } from '../../services/identity';
import { Api } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';

const SignUpPage = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { t } = useLanguage();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus(null);

    const trimmedName = name.trim();
    const trimmedPhone = phone.trim();

    if (!trimmedName) {
      setStatus(t('signup.status_name_required'));
      return;
    }
    if (!trimmedPhone) {
      setStatus(t('signup.status_phone_required'));
      return;
    }

    setSubmitting(true);
    try {
      const identityPayload = {
        phoneNumber: trimmedPhone,
        firstName: trimmedName,
      };
      const identityResponse = await createIdentityUser(identityPayload);
      const identityData = identityResponse?.data || identityResponse;
      const successFlag =
        typeof identityResponse?.status !== 'undefined'
          ? identityResponse.status
          : identityData?.status;

      if (!successFlag) {
        throw new Error(t('signup.status_create_failed'));
      }

      const savedUser = identityData?.data || identityData;
      const userId = savedUser?.user_id || savedUser?.id;

      if (userId) {
        await Api.createCustomerProfile({
          customerId: userId,
          firstName: trimmedName,
          phoneNumber: trimmedPhone,
        });
      }

      const otpResult = await requestOtp(trimmedPhone, {
        id: userId,
        name: trimmedName,
      });

      if (!otpResult.success) {
        throw new Error(otpResult.message || t('signup.status_otp_failed'));
      }

      setStatus(t('signup.status_otp_sent'));
      setName('');
      setPhone('');
      window.location.assign('/otp');
    } catch (error) {
      setStatus(error.message || t('signup.status_create_failed'));
    }
    setSubmitting(false);
  };

  return (
    <div className="login signup">
      <div className="login__content">
        <img src={logo} alt="Wassini logo" className="login__logo" />
        <h1 className="login__title">{t('signup.title')}</h1>
        <form className="login__form" onSubmit={handleSubmit}>
          <label>
            <span>{t('signup.full_name_label')}</span>
            <input
              type="text"
              name="name"
              placeholder={t('signup.full_name_placeholder')}
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </label>
          <label>
            <span>{t('signup.phone_label')}</span>
            <input
              type="tel"
              name="phone"
              placeholder={t('signup.phone_placeholder')}
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
            />
          </label>
          {status && <p className="login__status">{status}</p>}
          <button
            type="submit"
            className="button button--primary login__submit"
            disabled={submitting}
          >
            {submitting ? t('signup.creating') : t('signup.create_cta')}
          </button>
        </form>
        <p className="login__signup">
          {t('signup.already')}{' '}
          <a href="/login" className="login__signup-link">
            {t('signup.login')}
          </a>
        </p>
        <p className="login__powered">
          {t('signup.powered')} <span>Softwarezz</span>
        </p>
      </div>
    </div>
  );
};

export default SignUpPage;
